<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <!-- Header de transacciones -->
    <div class="py-1 flex justify-center dashboard-header">
      <h2 class="text-xl text-white font-semibold mb-0">Configuraciones</h2>
    </div>

    <!-- Lista paginada de configuraciones -->
    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">

      <!-- Spinner loading -->
      <div *ngIf="loadingConfig" class="w-full text-center">
        <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
      </div>

      <!-- Lista con filtros -->
      <app-generic-list class="w-full flex-col"
        *ngIf="ConfigList.length > 0 && !loadingConfig"
        filterKeyPrefix="configs"
        [items]="ConfigList"
        (itemClick)="onConfigClick($event)"
        [filterFields]="filterConfigs"
        [showFilters]="true"
        [isFiltersCollapsed]="true"
        [allowDownload]="false"
        (pageChanged)="loadMoreConfigs($event)"
        (filtersChanged)="onFiltersChanged($event)"
        (filteredCount)="filteredCounts.ConfigList= $event"
        [pageSize]="configsPerPage">

        <ng-template #tableHeaderTemplate>
          <div class="grid grid-cols-6 gap-4 items-center border-b py-2 font-semibold text-sm text-gray-700">
            <div class="col-span-1 truncate">ID</div>
            <div class="col-span-1 truncate">Módulo</div>
            <div class="col-span-2 truncate">Nombre</div>
            <div class="col-span-2 truncate">Valor</div>
          </div>
        </ng-template>

        <ng-template #itemTemplate let-item>
        <div
          class="grid grid-cols-4 gap-4 items-center border-b py-2 cursor-pointer hover:bg-gray-100 px-2"
          [title]="item.nombre"
        >
          <div class="w-full truncate text-sm text-gray-500">{{ item.id }}</div>
          <div class="w-full truncate text-sm text-gray-500">{{ item.Modulo }}</div>
          <div class="w-full truncate text-sm text-gray-500">{{ item.nombre }}</div>
          <div class="w-full truncate text-sm text-gray-500">{{ item.valor }}</div>
        </div>
        </ng-template>

      </app-generic-list>

      <!-- Mensaje si no hay configuraciones -->
      <div *ngIf="!loadingConfig && ConfigList.length === 0" class="w-full content-center h-[200px] flex flex-col justify-center items-center text-center text-gray-400">
        <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">settings</mat-icon>
        <p class="!font-medium mt-4">No se encontraron configuraciones</p>
      </div>

    </div>
  </div>

  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
